import { RefObject } from 'react';
import { ViewIds } from '@ardoq/api-types';
import { DependencyMapViewSettings } from '@ardoq/dependency-map';
import { ExportViewEvent, getExportsForHtmlView } from '@ardoq/export';
import { getExportLabels } from 'views/getExportLabels';
import { SettingsBar } from '@ardoq/settings-bar';
import { getRightMenuConfig } from 'viewSettings/getRightMenuConfig';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { OnViewSettingsUpdate } from '@ardoq/data-model';
import { getStyleSheets } from 'tabview/getSharedExportFunctions';
import { type I18nLocale } from '@ardoq/i18n';
import {
  toWorkspaceModeSettingsControls,
  type WorkspaceModeDependencyMapSettingsControlsDependencies,
} from '../workspaceMode/settingsControls';

export type DependencyMapSettingsBarProps = {
  viewSettings: DependencyMapViewSettings;
  settingsControlsDependencies: WorkspaceModeDependencyMapSettingsControlsDependencies;
  onViewSettingsUpdate: OnViewSettingsUpdate;
  quickPerspectiveReferenceTypeFilters: Set<string> | null;
  i18nLocale: I18nLocale;
  containerRef: RefObject<HTMLElement | null>;
  isEmptyView: boolean;
  trackingFunction: (metadata: ExportViewEvent) => void;
  addToPresentation: (name: ViewIds, isViewpointMode: boolean) => void;
};

const VIEW_ID = ViewIds.DEPENDENCY_MAP_2;

const DependencyMapSettingsBar = ({
  viewSettings,
  containerRef,
  settingsControlsDependencies,
  onViewSettingsUpdate,
  trackingFunction,
  addToPresentation,
  isEmptyView,
  quickPerspectiveReferenceTypeFilters,
  i18nLocale,
}: DependencyMapSettingsBarProps) => {
  const exports = {
    ...getExportsForHtmlView({
      container: () => containerRef.current,
      exportedViewMetadata: {
        name: VIEW_ID,
        isViewpointMode: false,
      },
      trackingFunction,
      addToPresentation,
      showPresentationOption: true,
      getStyleSheets,
      labels: getExportLabels(i18nLocale),
    }),
    isDisabled: isEmptyView,
  };
  return (
    <SettingsBar
      viewId={VIEW_ID}
      i18nLocale={i18nLocale}
      leftMenu={
        settingsControlsDependencies
          ? toWorkspaceModeSettingsControls({
              dependencies: settingsControlsDependencies,
              onViewSettingsUpdate,
              quickPerspectiveReferenceTypeFilters,
              i18nLocale,
            })
          : []
      }
      rightMenu={getRightMenuConfig({
        isViewpointMode: false,
        viewId: VIEW_ID,
        viewstate: viewSettings,
        exports,
        knowledgeBaseLink: KnowledgeBaseLink.DEPENDENCY_MAP_2,
        onViewSettingsUpdate,
        i18nLocale,
      })}
    />
  );
};

export { DependencyMapSettingsBar };
